"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeaderCell = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const classFunctions_1 = require("../../../utils/classFunctions");
const Icon_1 = require("../../Icon");
const TableHeaderCell = (props) => {
    var _a;
    const { column: rawColumn, isMultiSortDisabled, selectionProps, tableRef, tableModificators, } = props;
    tableRef.current.useCellMount(-1, rawColumn.id);
    const getOnSortByToggleClick = (column) => {
        return column.canSort ? { onClick: (e) => {
                e.persist();
                column.toggleSortBy(!column.isSortedDesc, isMultiSortDisabled);
            } } : {};
    };
    const column = rawColumn;
    const classNames = (0, classFunctions_1.getClasses)(`${__1.className}__header-cell`, (_a = tableModificators === null || tableModificators === void 0 ? void 0 : tableModificators.column) === null || _a === void 0 ? void 0 : _a.call(tableModificators, column));
    if (column.headerClasses)
        classNames.push(...column.headerClasses);
    const headerProps = [
        column.getSortByToggleProps(),
        getOnSortByToggleClick(column),
        { style: column.style },
    ];
    return (react_1.default.createElement("th", { ...column.getHeaderProps(headerProps), className: classNames.join(' ') },
        column.render('Header', {
            ...selectionProps,
            tableRef,
        }),
        column.canSort && (react_1.default.createElement("span", { className: (0, classFunctions_1.getClassNames)(`${__1.className}__sort-by`, [
                !column.isSorted ? 'not-active' : undefined,
            ]) },
            column.isSorted && (column.isSortedDesc
                ? react_1.default.createElement(Icon_1.Icon, { name: 'sort-down' }) : react_1.default.createElement(Icon_1.Icon, { name: 'sort-up' })),
            !column.isSorted && (react_1.default.createElement(Icon_1.Icon, { name: 'sort' }))))));
};
exports.TableHeaderCell = TableHeaderCell;
//# sourceMappingURL=headerCell.js.map